import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLanguage, t } from '../../context/LanguageContext';

const API_URL = process.env.REACT_APP_API_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem('portalToken')}` } });

function fmtDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function todayISODate() {
  return new Date().toISOString().slice(0, 10);
}

export default function PortalEventsListPage() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/portal/events`, auth())
      .then(r => setEvents(r.data.events || []))
      .catch(() => setError(t('Failed to load events.', 'Error al cargar los eventos.', lang)))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const today = todayISODate();

  if (loading) return <div className="text-center py-5"><span className="spinner-border spinner-border-sm" /></div>;
  if (error) return <div className="alert alert-warning m-3" style={{ fontSize: 13 }}>{error}</div>;

  if (events.length === 0) {
    return (
      <div className="text-center text-muted py-5" style={{ fontSize: 14 }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>📅</div>
        <p>{t('No active events right now.', 'No hay eventos activos en este momento.', lang)}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '16px' }}>
      <h6 className="fw-bold mb-3">{t('Events', 'Eventos', lang)}</h6>
      <div className="d-flex flex-column gap-2">
        {events.map(ev => {
          const isActive = ev.startDate <= today && ev.endDate >= today;
          return (
            <div key={ev.id} className="card">
              <div className="card-body py-2 px-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="fw-semibold" style={{ fontSize: 14 }}>{ev.name}</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {fmtDate(ev.startDate)} – {fmtDate(ev.endDate)}
                      {isActive && (
                        <span className="badge bg-success ms-2" style={{ fontSize: 10 }}>
                          {t('Today', 'Hoy', lang)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-2 mt-2">
                  {ev.isInventoryManager && (
                    <button
                      className="btn btn-sm btn-outline-primary"
                      style={{ fontSize: 12 }}
                      onClick={() => navigate(`/portal/events/${ev.id}`)}
                    >
                      {t('Inventory', 'Inventario', lang)}
                    </button>
                  )}
                  {ev.isPoolMember && (
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      style={{ fontSize: 12 }}
                      onClick={() => navigate(`/portal/events/${ev.id}/schedule`)}
                    >
                      {t('My Schedule', 'Mi Horario', lang)}
                    </button>
                  )}
                  {!ev.isInventoryManager && !ev.isPoolMember && (
                    <span className="text-muted" style={{ fontSize: 12 }}>
                      {t('No role assigned', 'Sin rol asignado', lang)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
